<template>
  <section>
    <div class="w-full flex flex-wrap items-center justify-between mb-6 mt-3">
      <h2>Member 2-Step Verification</h2>
    </div>
    <p class="text-gray-700 mb-6">
      Require every member of your program to enter a code, emailed to them, each time they sign in
      with their email and password. Members are asked for the code at their next sign-in and can't
      turn it off while this is on. When you turn it off, each member goes back to their own choice.
    </p>

    <form @submit.prevent="handleSubmit">
      <CustumLabel name="member_two_factor_required" :error="errors.member_two_factor_required">
        <div class="flex items-center gap-3">
          <Switch v-model:checked="required" />
          <span class="text-black">Require 2-step verification for all members</span>
        </div>
      </CustumLabel>

      <div class="mt-6">
        <Button
          type="primary"
          html-type="submit"
          class="btn-gradient rounded"
          size="large"
          block
          :loading="loading"
          :disabled="!isChanged"
          >Save</Button
        >
      </div>
    </form>
  </section>
</template>

<script>
import {
  Button, Modal, Switch, message,
} from 'ant-design-vue';
import CustumLabel from '@/components/shared/form/CustumLabel.vue';
import authApi from '@/services/apis/auth.api';
import { AUTH } from '@/store/types';
import handleResErrors from '@/utils/handleResErrors';

export default {
  components: {
    Button,
    Switch,
    CustumLabel,
  },
  data() {
    return {
      required: false,
      errors: {},
      loading: false,
    };
  },
  computed: {
    user() {
      return this.$store.state.auth.user || null;
    },
    isChanged() {
      return this.required !== !!this.user?.member_two_factor_required;
    },
  },
  watch: {
    user: {
      immediate: true,
      handler() {
        this.required = !!this.user?.member_two_factor_required;
      },
    },
  },
  methods: {
    handleSubmit() {
      if (!this.isChanged) {
        return;
      }
      if (!this.required) {
        this.save();
        return;
      }
      // Turning it on changes every member's next sign-in, so confirm first.
      Modal.confirm({
        title: 'Require 2-step verification for all members?',
        content: "Each member will need a code emailed to them at their next sign-in with a password, and won't be able to turn it off.",
        okText: 'Require it',
        cancelText: 'Cancel',
        onOk: () => this.save(),
      });
    },
    async save() {
      this.loading = true;
      this.errors = {};

      try {
        await authApi.updateUser({
          member_two_factor_required: this.required,
        });
        const data = await authApi.getUser();
        this.$store.commit(AUTH.SET_USER_DATA, data);
        message.success('Updated successfully');
      } catch (error) {
        const errors = error.response?.data?.errors || {};
        this.errors = Object.fromEntries(
          Object.entries(errors).map(([key, val]) => [key, Array.isArray(val) ? val[0] : val]),
        );
        message.error(handleResErrors(error), 10);
      }
      this.loading = false;
    },
  },
};
</script>
